import { render, staticRenderFns } from "./HsabExpenseForm.vue?vue&type=template&id=95fd4944&scoped=true"
import script from "./HsabExpenseForm.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseForm.vue?vue&type=script&lang=ts"
import style0 from "./HsabExpenseForm.vue?vue&type=style&index=0&id=95fd4944&prod&lang=scss"
import style1 from "./HsabExpenseForm.vue?vue&type=style&index=1&id=95fd4944&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fd4944",
  null
  
)

export default component.exports